import axios from 'axios'
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import * as React from 'react'

import ViewTracker from '@/components/common/view-tracker'
import SEO from '@/components/seo/SEO'
import BlogUserContentContainer from '@/containers/blogs/user-blog-container'
import RootContainer from '@/containers/root-container'

import blogService from '@/services/blog.service'
import { createServerSideApiConfig } from '@/utils/api.utils'

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const { locale, res } = context
  const slug = context.params?.slug

  res?.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59')

  if (!slug || typeof slug !== 'string') {
    return { notFound: true }
  }

  try {
    const blog = await blogService.getBlogBySlug(slug, locale, createServerSideApiConfig(context))
    return {
      props: { blog },
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { notFound: true }
    }
    throw error
  }
}

function UserBlogDetailPage({ blog }: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <RootContainer>
      <SEO
        title={blog.title}
        description={blog.metaDescription}
        ogImage={blog.thumbnailImage}
        ogType="article"
        publishedTime={blog.createdAt}
        modifiedTime={blog.updatedAt}
        section="Blog"
      />
      {blog?.id != null && <ViewTracker entityType="blog" entityId={String(blog.id)} />}
      <BlogUserContentContainer blog={blog} />
    </RootContainer>
  )
}

export default UserBlogDetailPage
